// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"Y0-z"};